import type { IconNameType } from 'components/Icon/types';

const ICON_TYPES_MAP: Record<string, IconNameType> = {
  folder: 'antdFolderFilled',
  image: 'antdFileImageOutlined',
  audio: 'antdSoundOutlined',
  video: 'antdVideoCameraOutlined',
  'application/pdf': 'antdFilePdfOutlined',
  'application/msword': 'antdFileWordOutlined',
  'application/vnd.ms-word': 'antdFileWordOutlined',
  'application/vnd.oasis.opendocument.text': 'antdFileWordOutlined',
  'application/vnd.openxmlformats-officedocument.wordprocessingml':
    'antdFileWordOutlined',
  'application/vnd.ms-excel': 'antdFileExcelOutlined',
  'application/vnd.openxmlformats-officedocument.spreadsheetml':
    'antdFileExcelOutlined',
  'application/vnd.oasis.opendocument.spreadsheet': 'antdFileExcelOutlined',
  'application/vnd.ms-powerpoint': 'antdFilePptOutlined',
  'application/vnd.openxmlformats-officedocument.presentationml':
    'antdFilePptOutlined',
  'application/vnd.oasis.opendocument.presentation': 'antdFilePptOutlined',
  'text/plain': 'antdFileTextOutlined',
  'text/html': 'antdCodeOutlined',
  'application/json': 'antdCodeOutlined',
  'application/zip': 'antdFileZipOutlined',
  'application/gzip': 'antdFileZipOutlined',
  'application/x-shockwave-flash': 'antdYoutubeFilled',
};

export const mimeTypeToIcon = (mimeType: string): IconNameType => {
  // List of official MIME Types: http://www.iana.org/assignments/media-types/media-types.xhtml
  let iconClass;
  Object.keys(ICON_TYPES_MAP).forEach(iconType => {
    if (mimeType.includes(iconType)) {
      iconClass = ICON_TYPES_MAP[iconType];
    }
  });
  return iconClass || 'antdFileOutlined';
};
